import { action } from 'satcheljs';
export default action('loadCLPUserLabels');
